export const initialWidgetFilters = {
  qualityTracking: [{ filter_parameter: "status__in", filter_value: "W,I" }],
  myTaskExecutions: [
    { filter_parameter: "user", filter_value: "current_user" },
    { filter_parameter: "status", filter_value: "PENDING" },
  ],
};
